let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aD89V")).then(() => parcelRequire('7PhkK'));